import { FC, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from './index.module.scss';
import IconClose from './IconClose';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
interface IProps {
    callback?: any;
    planData: any;
}

const WinPolicy: FC<IProps> = ({ callback, planData }) => {
    const { t } = useLang('membersday.teaser.ReferralNext');
    const [isClient, setIsClient] = useState(false);
    const [tabActive, setTabActive] = useState('1');
    const { locale } = getLocal();
    const [listA, setListA] = useState([]);
    const [listB, setListB] = useState([]);
    const [shareTc, setShareTc] = useState<string>('');

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        if (planData?.planId) {
            setShareTc(planData.shareTc);
        }
    }, [planData]);

    if (!isClient) {
        return null;
    }
    const toggleHandle = (type: string) => {
        setTabActive(type);
    };

    return ReactDOM.createPortal(
        <div className={`glo-editor-modal glo-editor-modal-show ${styled.WinTable}`}>
            <div className="glo-editor-modal-wrap">
                <div className="modal-content policy">
                    <IconClose
                        className="win-close"
                        onClick={() => {
                            callback && callback();
                        }}
                    />
                    <div className="win-title">{t('linkBtn1')}</div>
                    {/* <div className="win-descTitle">{t('descTitle')}</div>
                    1111 */}
                    <div dangerouslySetInnerHTML={{ __html: shareTc }} className="win-content-desc"></div>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default WinPolicy;
